 <login-form
  (login)="login($event)"
  [appName]="appName"
  >
 </login-form>